module.exports = __webpack_public_path__ + "static/media/step-2-filled.45f52f67.svg";